<template>
<div>
    <NavBar/>
    <img class="about" v-if="!isMobile()" src="../assets/pages/about.jpg" alt="" usemap="#image-map">

    <img class="about" v-if="isMobile()" src="../assets/mobile/about.jpg" alt="" usemap="#image-map">
    <Footer/>
</div>
</template>

<script>
import NavBar from './Navigation/NavBar.vue'
import Footer from './Navigation/Footer.vue'
export default {
  components:{
    NavBar,
    Footer
  },
  created() {
    window.location.href = "https://chimbastudios.com/cosmic-labs"; // Replace with your desired URL
  },
  mounted()
  {
    $(document).ready(function(e) {
      $('img[usemap]').rwdImageMaps();
    });
  },
  methods:{
    isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
  }
}
</script>

<style scoped>
.about
{
  width: 100%;
  z-index: -1 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/About.vue